import { render, staticRenderFns } from "./yanchu_goods_nav_config.vue?vue&type=template&id=f88fc796&scoped=true"
import script from "./yanchu_goods_nav_config.vue?vue&type=script&lang=js"
export * from "./yanchu_goods_nav_config.vue?vue&type=script&lang=js"
import style0 from "./yanchu_goods_nav_config.vue?vue&type=style&index=0&id=f88fc796&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.0.0_f2752dac7684e9922cbc3a420999c69f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88fc796",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f88fc796')) {
      api.createRecord('f88fc796', component.options)
    } else {
      api.reload('f88fc796', component.options)
    }
    module.hot.accept("./yanchu_goods_nav_config.vue?vue&type=template&id=f88fc796&scoped=true", function () {
      api.rerender('f88fc796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/custom-layout/components/rightConfig/yanchu_goods_nav_config.vue"
export default component.exports